/** Booking form builder of a booking action (Actions → booking action → Booking form). */
export const bookingForm = {
  title: "Booking form",
  subtitle: "What visitors fill in when they book. Every answer is added to the calendar invitation and the lead.",
  fixed: "Always asked: full name and email address (the invitation is sent there).",
  askPhone: "Ask for a mobile number",
  askPhoneHint: "Optional for the visitor. Shown as Phone in the invitation.",
  askNotes: "Offer a notes box",
  askNotesHint: "A free text box at the end of the form.",
  fields: "Your fields",
  empty: "No fields yet. Add a field to ask for a company, a role, a team size and more.",
  addField: "Add field",
  label: "Question",
  labelPlaceholder: "e.g. Company",
  type: "Type",
  required: "Required",
  options: "Choices",
  optionsHint: "One choice per line.",
  optionsPlaceholder: "1-25\n26-100\n100+",
  moveUp: "Move {{name}} up",
  moveDown: "Move {{name}} down",
  remove: "Remove {{name}}",
  fieldN: "Field {{n}}",
  types: {
    text: "Short text",
    textarea: "Paragraph",
    select: "Dropdown",
    checkboxes: "Checkboxes",
    email: "Email",
    tel: "Phone",
  },
  preview: "Invitation preview",
  previewHint: "How the details appear in the Google Calendar invitation.",
  previewName: "Juan Dela Cruz",
  previewEmail: "juan@example.com",
  previewPhone: "+63 917 123 4567",
  previewAnswer: "(answer)",
  save: "Save form",
  saved: "Booking form saved",
  readOnly: "You can view this form. Ask an admin to change it.",
  errors: {
    label: "Enter the question.",
    labelMax: "Keep the question under {{count}} characters.",
    options: "Add at least one choice.",
    optionsMax: "Use at most {{count}} choices.",
    optionMax: "Keep each choice under {{count}} characters.",
    duplicateOption: "Each choice may appear only once.",
    duplicateLabel: "Two fields have the same question.",
    tooMany: "You can add up to {{count}} fields.",
  },
} as const;
